var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Flags"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_732_5478)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.300293,
    y: 0.5,
    width: 21,
    height: 15,
    rx: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.300293 0.5H9.30029V7.5H0.300293V0.5Z",
    fill: "#1A47B8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.30029 0.5V1.5H21.3003V0.5H9.30029ZM9.30029 2.5V3.5H21.3003V2.5H9.30029ZM9.30029 4.5V5.5H21.3003V4.5H9.30029ZM9.30029 6.5V7.5H21.3003V6.5H9.30029ZM0.300293 8.5V9.5H21.3003V8.5H0.300293ZM0.300293 10.5V11.5H21.3003V10.5H0.300293ZM0.300293 12.5V13.5H21.3003V12.5H0.300293ZM0.300293 14.5V15.5H21.3003V14.5H0.300293Z",
    fill: "#F93939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.30029 1.5V2.5H2.30029V1.5H1.30029ZM3.30029 1.5V2.5H4.30029V1.5H3.30029ZM5.30029 1.5V2.5H6.30029V1.5H5.30029ZM7.30029 1.5V2.5H8.30029V1.5H7.30029ZM6.30029 2.5V3.5H7.30029V2.5H6.30029ZM4.30029 2.5V3.5H5.30029V2.5H4.30029ZM2.30029 2.5V3.5H3.30029V2.5H2.30029ZM1.30029 3.5V4.5H2.30029V3.5H1.30029ZM3.30029 3.5V4.5H4.30029V3.5H3.30029ZM5.30029 3.5V4.5H6.30029V3.5H5.30029ZM7.30029 3.5V4.5H8.30029V3.5H7.30029ZM1.30029 5.5V6.5H2.30029V5.5H1.30029ZM3.30029 5.5V6.5H4.30029V5.5H3.30029ZM5.30029 5.5V6.5H6.30029V5.5H5.30029ZM7.30029 5.5V6.5H8.30029V5.5H7.30029ZM6.30029 4.5V5.5H7.30029V4.5H6.30029ZM4.30029 4.5V5.5H5.30029V4.5H4.30029ZM2.30029 4.5V5.5H3.30029V4.5H2.30029Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_732_5478"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.300293,
    y: 0.5,
    width: 21,
    height: 15,
    rx: 3,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnFlag);
export default __webpack_public_path__ + "static/media/en-flag.62a0df371165bd3764b9be722b2f1af2.svg";
export { ForwardRef as ReactComponent };